import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: "Piano d'Attacco 7 Giorni",
    desc: "Guida rapida per avviare l'anno con ordine.",
    val: '€80'
  }, {
    num: '02',
    title: 'Banca delle Spiegazioni Chiare',
    desc: '40 analogie per spiegare i concetti più complessi (senza farli sembrare geroglifici).',
    val: '€100'
  }, {
    num: '03',
    title: 'Kit di Attivazione',
    desc: "30 prompt e domande per catturare l'attenzione nei primi 5 minuti di lezione.",
    val: '€70'
  }, {
    num: '04',
    title: 'Rubriche Express',
    desc: 'Griglie pronte per valutare competenze, relazioni e laboratori.',
    val: '€60'
  }, {
    num: '05',
    title: 'Laboratorio Impossibile',
    desc: '25 esperimenti che puoi fare in una normale aula, usando materiali poveri (senza tecnico di laboratorio).',
    val: '€90'
  }, {
    num: '06',
    title: 'Coaching Comunicazione',
    desc: 'Modelli di email e comunicazioni per famiglie e studenti.',
    val: '€50'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-17">
            🎁 Esclusivi Bonus{' '}
            <span className="text-brand-accent" data-id="element-18">Strategici Inclusi</span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-19">
            Solo acquistando oggi, riceverai senza costi extra:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 border border-brand-border relative overflow-hidden" data-id="element-21">
              <div className="text-6xl font-heading font-black text-brand-accent/20 absolute top-3 right-4 leading-none" aria-hidden="true" data-id="element-22">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-23">
                <div className="text-brand-accent font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-24">
                  BONUS #{bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-3 pr-10 leading-tight" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-6 text-sm leading-relaxed" data-id="element-26">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-brand-border" data-id="element-27">
                  <div className="text-white/60 line-through text-sm" data-id="element-28">
                    Valore {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-29">
                    IN OMAGGIO
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-30">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-31">
            🎁 BONUS IN OMAGGIO — Solo per tempo limitato
          </h3>
          <p className="text-white/70 font-medium" data-id="element-32">
            Inclusi in tutte le offerte. Sempre.
          </p>
        </div>
      </div>
    </section>;
}